import {BranchSummary} from '../components/BranchSummary.js';

import React, {Component} from "react";
import jquery from 'jquery';
//import ReactAnimatedEllipsis from "react-animated-ellipsis";
import MDSpinner from "react-md-spinner";

/**
 * I'm the entry for a single project. I list some details
 * about the project and then all branches. From there one
 * can show more things.
 */
export class ProjectOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hosting: props.hosting,
      project: props.project,
      url: 'https://github.com/' + props.project,
      branches: [],
      loading: true
    };
  }

  queryBranches() {
    var url = 'https://api.bob-bench.org/v1/search/branches/' + this.state.repo_id;
    jquery.getJSON(url)
      .done(function(data) {
        var branches = {}
        data.forEach(function(each) {
            /* skip tags.. for now */
            if (each.tag === null)
              branches[each.ci_system + ":" + each.branch + ":" + each.sub_number] = each;
        });
        branches = Object.keys(branches).map((entry) => branches[entry]);
        branches.sort((a,b) => {
          return b.last_id - a.last_id;
        });

        this.setState({
          branches: branches,
          loading: false
          });
      }.bind(this))
      .fail(function(error, a, b) {
      });
  }

  queryRepoId() {
    var url = 'https://api.bob-bench.org/v1/search/repositories?'
                + jquery.param({'url': 'https://github.com/' + this.state.project});
    jquery.getJSON(url)
      .done(function(data) {
        this.setState({repo_id: data[0].id});
        this.queryBranches(); 
      }.bind(this))
      .fail(function(error, a, b) {
      });
  }

  componentDidMount() {
    this.queryRepoId();
  }

  render() {
    const branches = this.state.branches.map((entry) =>
      (
        <BranchSummary className="hidden" key={entry.last_id} branch={entry} repo_id={this.state.repo_id} project={this.state.project} />
      ));
    return (
      <div>
        <h1>{this.state.project} - overview</h1>
        <div className="row">
          <div className="col-md-12 table-responsive">
            <table className="table">
             <colgroup>
              <col className="col-md-4" />
              <col className="col-md-8" />
             </colgroup>
             <tbody>
              <tr><td>Project</td><td><i className="fa fa-github" aria-hidden="true"/> <a href={this.state.url}>{this.state.project}</a></td></tr>
            </tbody></table>
          </div>
        </div>
        {this.state.loading ? <h3>Loading branch information <MDSpinner/></h3> : <h3>Branches and builds</h3>}
        {branches}
      </div>);
  }
}





// WEBPACK FOOTER //
// ./src/views/ProjectOverview.js